// extracted by css-extract-rspack-plugin
export default {"cls1":"Avatar-cls1_k6x","cls2":"Avatar-cls2_h5B Avatar-cls1_k6x"};